import Vue from 'vue';
import axios, {AxiosRequestConfig, AxiosStatic} from 'axios';
import router from '@/router';
import store from '@/store';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function forbiddenRedirectLogin(error: any) {
  const status = error.response?.status;
  const requestUrl = error.response.config.url;
  const routeName = router.currentRoute.name;
  // Handle unauthorized result to clear token
  if (status === 401 && store.state.token) {
    store.commit('logout')
  }
  // Handle forbidden redirect login
  if (status === 403 && routeName !== 'login' && requestUrl !== process.env.VUE_APP_SESSION_API) {
    store.commit('logout');
    return router.push({ name: 'login' });
  }
  return Promise.reject(error);
}

/**
 * Automatically add authorization in headers.
 */
function authorizationHeader(config: AxiosRequestConfig) {
  if (store.state.token) {
    config.headers.Authorization = 'Token ' + store.state.token;
  }
  return config;
}

Vue.use({
  install() {
    const axiosInstance = axios.create({
      /* eslint-disable-next-line no-undef */
      // Adding base URL foreach axios request.
      baseURL: process.env.VUE_APP_ROOT_API ?? '/',
      // Tells axios the name of the CSRF Token in cookies in order to retreive it automatically.
      xsrfCookieName: 'csrftoken',
      // Tells axios the header name to put on each request for CSRF Token.
      xsrfHeaderName: 'X-CSRFTOKEN',
      withCredentials: true,
    });
    // In case of response error Forbidden, redirect to Login page.
    axiosInstance.interceptors.request.use(authorizationHeader);
    axiosInstance.interceptors.response.use(undefined, forbiddenRedirectLogin);

    Vue.prototype.$axios = axiosInstance;
  },
});

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosStatic;
  }
}
